import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscribedUserComponent } from './subscribed-user.component';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    SubscribedUserComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
  ]
})
export class SubscribedUserModule { }
